import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import {withStyles} from "@mui/styles";
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

const styles = () => ({
  menu: {
    width: 200
  }
});

class SalesProduct extends React.Component {
  /*
   * Remove soft-deleted products except one that the placement already has
   * The JAG compound salesProducts are not for Programmatic.
   * The PROG compound salesProducts are for Programmatic only.
   */

  handleChange = selected => {
    if (this.isChangeAllowed(selected.target.value)) {
      const evt = {
        target: {
          name: 'SalesProductId',
          value: selected.target.value
        }
      };
      this.props.onChange(evt);
    } else {
      alert('Cannot change SalesProduct in this way');
    }
  }

  /**
   * Compare prior and current sales products
   * If there is no prior (it's a new placement) there is no problem
   * If no change, it's ok
   * If they both have no line items or both have one line item, change is allowed
   * Changes to and from multiple line item models for pushed placements are only
   * allowed for specific cases.
   * @param newId
   * @returns whether sales product can be changedg
   */
  isChangeAllowed = newId => {
    const { constants, salesProducts, priorSalesProduct, isPushed } = this.props;
    const oldSP = priorSalesProduct;
    const newSP = salesProducts.find(sp => sp.id === newId);
    let changeAllowed = false;
    if (!oldSP) {
      return true;
    }
    if (!newSP) {
      return true;
    }
    if (oldSP.code === newSP.code) {
      changeAllowed = true;
    }
    if (!isPushed) {
      changeAllowed = true;
    }
    if (oldSP.name === 'MTR Contextual' && newSP.name === 'MTR Contextual + Intrasite') {
      changeAllowed = true;
    } else if (oldSP.name === 'JAG Contextual' && newSP.name === 'JAG Contextual + Intrasite') {
      changeAllowed = true;
    }
    if (constants.spNotAdManager.includes(oldSP.code)) {
      changeAllowed = constants.spNotAdManager.includes(newSP.code);
    }
    if (isPushed && !constants.spNotAdManager.includes(oldSP.code)) {
      console.error('Pushed already; new SP disallowed');
      return !constants.spNotAdManager.includes(newSP.code);
    }
    return changeAllowed;
  }

  getSalesProducts = () => {
    const { salesProducts, orderType, value } = this.props;
    if (isEmpty(salesProducts)) {
      return [{ id: 0, name: 'No Options - Please select strategy' }];
    }
    let sps = salesProducts.filter(sp => !sp.deletedAt || sp.id === value);
    if (orderType === 'Programmatic') {
      sps = sps.filter(sp => sp.code !== 'JCI' && sp.code !== 'JNU' && sp.code !== 'JNUI');
      return sps;
    }
    sps = sps.filter(sp => sp.name.slice(0, 4) !== 'PROG');
    return sps;
  };

  render() {
    const { classes, value, disabled } = this.props;
    const salesProducts = this.getSalesProducts();

    return (
      <TextField
        variant="standard"
        select
        fullWidth
        disabled={disabled}
        name="SalesProductId"
        margin="normal"
        label="Sales Product"
        value={value}
        onChange={this.handleChange}
        SelectProps={{
          MenuProps: {
            className: classes.menu
          }
        }}>
        {salesProducts.map(sp => (
          <MenuItem key={sp.name} value={sp.id}>
            {sp.name}
          </MenuItem>
          ))}
      </TextField>
    );
  }
}

SalesProduct.defaultProps = {
  salesProducts: []
};

SalesProduct.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired,
  salesProducts: PropTypes.arrayOf(PropTypes.object),
  strategy: PropTypes.object,
  disabled: PropTypes.bool.isRequired
};

export default withStyles(styles)(SalesProduct);
